module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_4.7c1bd52a.png";